export const ENTITY_MAP = {
  company: {
    label: 'Empresas',
    encoded: 'Y29tcGFueQ==',
    nameField: 'name',
    descriptionField: 'document_number',
    queryHook: 'useGetCompaniesQuery',
    dataKey: 'companies'
  },
  office: {
    label: 'Dependencias',
    encoded: 'b2ZmaWNl',
    nameField: 'name',
    descriptionField: null,
    queryHook: 'useGetOfficesQuery',
    dataKey: 'offices'
  },
  attachment_type: {
    label: 'Tipos de Documento',
    encoded: 'YXR0YWNobWVudF90eXBl',
    nameField: 'name',
    descriptionField: null,
    queryHook: 'useGetAttachmentTypesQuery',
    dataKey: 'attachmentTypes'
  }
};
  
  export const getEntityConfig = (type) => ENTITY_MAP[type] || {};